import React, { useState } from 'react';

import { CornersIcon } from '@radix-ui/react-icons';
import { DataTable, DataTableColumnDef, IconButton } from '@raystack/apsara';

import { Header } from '@src/components/Custom/Header';

import { ExpandedTableDialog } from './ExpandedTableDialog';

import styles from './customTable.module.css';

interface DataRecord {
  [key: string]: string | number;
}

export const CustomTable: React.FC<{
  columns: DataTableColumnDef<DataRecord, unknown>[];
  data: DataRecord[];
}> = ({ columns, data }) => {
  const [expandTable, setExpandTable] = useState(false);

  return (
    <>
      <div className={styles.table}>
        <DataTable
          columns={columns}
          data={data}
          defaultSort={{ name: 'date', order: 'desc' }}
        >
          <Header
            className={styles.tableHeader}
            actions={
              <IconButton
                size={3}
                data-test-id='cornersIcon-table-btn'
                onClick={() => setExpandTable(!expandTable)}
              >
                <CornersIcon data-test-id='CornersIcon-table-icon' />
              </IconButton>
            }
          >
            <Header.Text>Output</Header.Text>
          </Header>
          <DataTable.Content />
        </DataTable>
      </div>

      <ExpandedTableDialog
        open={expandTable}
        onClose={() => setExpandTable(false)}
        columns={columns}
        data={data}
      />
    </>
  );
};
